import * as React from "react";
import type { SVGProps } from "react";
const SvgMicrophoneOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.792 6.516v5.488a4.116 4.116 0 0 0 7.592 2.207M2.4 13.375a9.607 9.607 0 0 0 19.014 0M16.024 9V6.516A4.116 4.116 0 0 0 9.769 3M4.2 2.4l17.4 17.4"
    />
  </svg>
);
export default SvgMicrophoneOff02;
